import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useOutletContext } from 'react-router'
import useTitles from 'common/hooks/useTitles'
import useFetch from 'common/hooks/useFetch'
import ApplicationConf from 'conf/ApplicationConf'
import LotsView from 'gdl/customer/components/lots/LotsView'

// Vue globale : tous les lots (ou toutes les idées) de tous les clients. Le nom du client est rapatrié
// depuis le store clients (fourni par CustomersApp via l'outlet context) et injecté dans chaque lot
// (clientName). Le filtre (dont la colonne Clients, active car `customers` est fourni) est porté par LotsView.
const AllLotsApp = ({ ideas = false }) => {
    const { customers = [] } = useOutletContext()

    useTitles(() => [{
        label: 'Clients', href: '/customer',
    }, ideas ? {
        label: 'Idées', href: '/customer/ideas',
    } : {
        label: 'Lots', href: '/customer/lots',
    }], [ideas])

    const { data: lots = [], reload } = useFetch(ApplicationConf.gdl.allLots())
    const { data: allTickets = [] } = useFetch(ApplicationConf.support.statisticsCreated(), { method: 'POST', body: {} })

    const clientById = useMemo(() => {
        const map = {}
        customers.forEach(cust => {
            map[cust.id] = { name: cust.name?.value ?? cust.name, mnemonic: cust.mnemonic?.value ?? cust.mnemonic }
        })
        return map
    }, [customers])

    const lotsWithClient = useMemo(
        () => lots.map(lot => ({ ...lot, clientName: clientById[lot.idClient]?.name, clientMnemonic: clientById[lot.idClient]?.mnemonic })),
        [lots, clientById],
    )

    return (
        <LotsView
            lots={lotsWithClient}
            ideas={ideas}
            reload={reload}
            allTickets={allTickets}
            customers={customers}
            emptyLabel={ideas ? 'Aucune idée.' : 'Aucun lot.'}
            defaultView='table'
            viewStorageKey='aquaparc-lots-view-all'
            filterStorageKey={ideas ? 'aquaparc-ideas-filter-all' : 'aquaparc-lots-filter-all'}
        />
    )
}

AllLotsApp.propTypes = {
    ideas: PropTypes.bool,
}

export default AllLotsApp
